import { faMagnifyingGlass as n, faPhone as f, faLock as o, faDollarSign as c, faEnvelope as i, faCreditCard as l, faCaretRight as a, faCaretLeft as e, faCaretDown as t, faCaretUp as r, faPen as p, faCircleX as g, faCalendarDays as s } from "@fortawesome/pro-solid-svg-icons";
const d = {
  caratUp: r,
  caratDown: t,
  caretLeft: e,
  caretRight: a,
  creditCard: l,
  envelope: i,
  dollarSign: c,
  lock: o,
  phone: f,
  magnifyingGlass: n
}, h = {
  caratUp: r,
  caratDown: t,
  caretLeft: e,
  caretRight: a,
  calendar: s,
  circleX: g,
  pen: p
};
export {
  d as leftIconOptions,
  h as rightIconOptions
};
